<template>
  <div
    class="flex flex-col lg:flex-row"
  >
    <div
      class=" w-full p-0 z-30 relative"
    >
      <HoldersPageContainer
        :edit-mode="editMode && insideOverviewOrIPPage"
      />
    </div>
  </div>
</template>
<script>

import HoldersPageContainer from '@/modules/holdersPage'
import companyPageMixin from '@/mixins/companyPageMixin'
import { useCompaniesStore } from '../stores/companies'

export default {
  name: 'CompanyHolders',
  components: {
    HoldersPageContainer
  },
  mixins: [companyPageMixin],
  setup() {
    const companiesStore = useCompaniesStore()

    return { companiesStore }
  },
  metaInfo () {
    return {
      title: `${this.companyName}  ${this.$t('Holders')}`
    }
  },
  computed: {
    company() {
        return this.companiesStore.selectedCompany 
    },
    companyName () {
      if (!this.company) return `${this.$t('Company')}`
      return this.company.name
    }
  }
}
</script>
